

import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const styles = {
    footer: {
      background: "#0f172a",
      color: "#e5e7eb",
      marginTop: "50px",
      padding: "10px 10px",
      width: "100%",
    },
    container: {
      width: "100%",
      maxWidth: "1400px",   // 🔥 wide footer
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "30px",
      padding: "0 20px",
    },
    logo: {
      color: "#22c55e",
      marginBottom: "10px",
      fontSize: "22px",
    },
    col: {
      marginBottom: "20px",
    },
    heading: {
      marginBottom: "12px",
      color: "#ffffff",
      fontSize: "16px",
    },
    text: {
      fontSize: "14px",
      lineHeight: "1.6",
      color: "#cbd5f5",
      margin: "6px 0",
    },
    link: {
      display: "block",
      fontSize: "14px",
      color: "#cbd5f5",
      textDecoration: "none",
      marginBottom: "8px",
      transition: "0.3s",
    },
    bottom: {
      borderTop: "1px solid #1e293b",
      textAlign: "center",
      padding: "18px",
      fontSize: "13px",
      color: "#94a3b8",
      marginTop: "30px",
      width: "100%",
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        
        {/* BRAND */}
        <div style={styles.col}>
          <h3 style={styles.logo}>KingShop</h3>
          <p style={styles.text}>
            India’s trusted online shopping platform.  
            Best quality products at the best price.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div style={styles.col}>
          <h4 style={styles.heading}>Quick Links</h4>
          <Link to="/about" style={styles.link}>About Us</Link>
          <Link to="/contact" style={styles.link}>Contact Us</Link>
          <Link to="/privacy-policy" style={styles.link}>Privacy Policy</Link>
          <Link to="/terms" style={styles.link}>Terms & Conditions</Link>
          <Link to="/refund" style={styles.link}>Refund & Cancellation</Link>
        </div>

        {/* CONTACT */}
        <div style={styles.col}>
          <h4 style={styles.heading}>Contact</h4>
          <p style={styles.text}>📧 kingshoppy.as@gmail.com</p>
          <p style={styles.text}>📞 +91 89668 25777</p>
          <p style={styles.text}>🕘 Mon–Sat (10AM–6PM)</p>
        </div>
      </div>

      {/* BOTTOM */}
      <div style={styles.bottom}>
        © {new Date().getFullYear()} KingShop. All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
